// import FloorplanView from "../Classes/FloorplanView";
import { fadeIn, fadeOut } from "../Helper/helper";

// This will handle all triggered events
export let EventHandler = {
  mousedownEvent: null,
  wheelEvent: null,
  dragEvent: null,
  dragStartX: null,
  dragStartY: null,
  dragMovedX: 0,
  dragMovedY: 0,
  mousemoved: false,
  pinched: false,
  scrolling: false,
  pinchScale: 1,
  mousedown: function (event) {
    // event.cancelBubble = true;
    // event.preventDefault();
    // EventHandler.mousedownEvent = event;
    // const target = event.target;
  },
  wheel: function (event) {
    // show scroll message
    if (!event.ctrlKey && !event.metaKey) {
      const message = window.FloorplanView.container.querySelector(
        ".mb-floorplan-container-eventmessage"
      );

      // fadeIn scroll message
      if (!window.floorplanScrolling) {
        window.floorplanScrolling = true;
        fadeIn(message, "flex");
      }

      // fadeOut scroll message
      clearTimeout(window.floorplanScrollingTimeout);
      window.floorplanScrollingTimeout = setTimeout(function () {
        window.floorplanScrolling = false;
        fadeOut(message, "flex");
      }, 2000);

      return;
    }

    // zoom
    event.cancelBubble = true;
    event.preventDefault();
    EventHandler.wheelEvent = event;

    if (event.deltaY > 0) {
      window.DataActionController["zoomwheel"]("out", event);
      window.FloorplanView.closePopup();
    } else if (event.deltaY < 0) {
      window.DataActionController["zoomwheel"]("in", event);
      window.FloorplanView.closePopup();
    }
  },
  pinch: function (event) {
    /**
     * two finger zoom
     * realized with hammer.js
     */
    event.cancelBubble = true;
    event.preventDefault();
    EventHandler.wheelEvent = event;
    this.mousemoved = true;
    this.pinched = true;

    const currentPinchScale = event.scale;

    if (currentPinchScale > this.pinchScale) {
      // window.DataActionController["zoomwheel"]("in", event);
      window.DrawingController.zoomIn();
      this.pinchScale = currentPinchScale;
      window.FloorplanView.closePopup();
    } else if (currentPinchScale < this.pinchScale) {
      // window.DataActionController["zoomwheel"]("out", event);
      window.DrawingController.zoomOut();
      this.pinchScale = currentPinchScale;
      window.FloorplanView.closePopup();
    }
  },
  dragstart: function (event) {
    const svgWrapper = window.DrawingController.svgWrapper;
    const svgContainer = window.DrawingController.svgContainer;
    const svgContainerBounding = svgContainer.getBoundingClientRect();
    const scrollTop = window.scrollY ?? document.body.scrollTop;
    event.cancelBubble = true;
    event.preventDefault();

    this.dragEvent = event;

    if (event.type == "touchstart") {
      this.dragStartX = event.touches[0].pageX;
      this.dragStartY = event.touches[0].pageY;
    } else {
      this.dragStartX = event.pageX;
      this.dragStartY = event.pageY;
    }

    // Cancel if dragstart outside SVG viewer (needed for touch handler)
    if (
      svgContainerBounding.left > this.dragStartX ||
      svgContainerBounding.left + svgContainer.offsetWidth < this.dragStartX ||
      scrollTop + svgContainerBounding.top > this.dragStartY ||
      scrollTop + svgContainerBounding.top + svgContainer.offsetHeight <
        this.dragStartY
    ) {
      return;
    }

    DrawingController.svgDragStartX = svgWrapper.offsetLeft;
    DrawingController.svgDragStartY = svgWrapper.offsetTop;

    // disable scrolling while draggging svg on touch devices
    if (event.type == "touchstart") {
      svgContainer.classList.add("dragging");
      document.body.classList.add("floorplan-dragging");
      document.body.style.overflow = "hidden";
      document.getElementsByTagName("html")[0].style.overflow = "hidden";
    }

    window.addEventListener("mousemove", window.DataActionController.drag, {
      passive: false,
    });

    window.addEventListener("touchmove", window.DataActionController.drag, {
      passive: false,
    });

    window.addEventListener("mouseup", this.dragend, {
      passive: false,
    });
    window.addEventListener("touchend", this.dragend, {
      passive: false,
    });
  },
  dragend: function (event) {
    window.removeEventListener("mousemove", window.DataActionController.drag);
    window.removeEventListener("mouseup", this.dragend);
    window.removeEventListener("touchmove", window.DataActionController.drag);
    window.removeEventListener("touchend", this.dragend);

    // enable scrolling after dragend svg on touch devices
    if (event.type == "touchend") {
      window.DrawingController.svgContainer.classList.remove("dragging");
      document.body.classList.remove("floorplan-dragging");
      document.body.style.overflow = "initial";
      document.getElementsByTagName("html")[0].style.overflow = "initial";
    }

    this.dragEvent = null;
  },
  click: function (event) {
    const that = this;
    setTimeout(function () {
      // window.EventHandler.mousemoved = false;
      that.mousemoved = false;
      that.pinched = false;
    }, 200);
  },
};
